<template>
    <div>
        <title-and-edit currentViewTitle="Personvern og samtykker" :layout="layout"/>
        <div v-if="consents.length" class="profile__container--content__consents primary-font mt-5">
            <profile-dropdown v-if="layout == 'portal'" :items="chains.map(x => x.chainName)" :layout="layout" @select-item="updateSalonList" :selectedChain="selectedChain"></profile-dropdown>  
            <div class="profile__container--content__consents--subtitle mt-3 mb-6">
                <span class="">{{consentsDescription}}</span>
            </div>
            <div v-if="layout == 'portal' && chainId == 0">
                <hr :class="`profile__container--navigation__${layout == 'portal' ? 'portal-linebreak' : 'linebreak'}`"/>
                <the-consent-toggle 
                    class="px-3 my-1"
                    switchColor="primary" 
                    :toggled="{toggleState: isAllToggled(fixitConsent.description), id: -1, parentDescription: fixitConsent.description}" 
                    @setState="setState" 
                    @openDropdown="dropdowns[fixitConsent.description] = !dropdowns[fixitConsent.description]" 
                    :title="fixitConsent.description" 
                    :icon="dropdowns[fixitConsent.description] ? 'fxt-chevron-down' : 'fxt-chevron-up'" 
                    :indeterminate="indeterminate(fixitConsent.description)">
                </the-consent-toggle>
                <v-expand-transition>
                    <div v-if="dropdowns[fixitConsent.description]">
                        <div v-for="subConsent in fixitConsent.children" :key="subConsent.consentTypeId">
                            <the-consent-toggle 
                                class="pr-3 pl-12" 
                                iconSize="20px" 
                                switchColor="primary" 
                                :toggled="{toggleState: subConsent.responseValue, id: subConsent.consentTypeId, parentDescription: fixitConsent.description}" 
                                :disabled="false" 
                                @setState="setState" 
                                :title="subConsent.consentCategory" 
                                :icon="icon(subConsent.consentTypeId)">
                            </the-consent-toggle>
                        </div>
                    </div>
                </v-expand-transition>
            </div>


            <div v-if="chainId == 0" class="profile__container--content__consents--subtitle mb-6" :class="chainId == 0 ? 'mt-12' : 'mt-3'">
                <div class="d-flex align-start pl-3">
                    <v-icon color="primary" size="28" class="pr-2">fxt-smile-beam</v-icon>
                    <span class="profile__container--content__consents--subtitle">Valgene under brukes når du legger til nye salonger. Dette påvirker ikke samtykkene du har satt i eksisterende salonger som kan finnes i nedtrekksmenyen.</span>
                </div>
            </div>



            <div v-for="(consent) in salonConsents" :key="consent.description">
                    <hr :class="`profile__container--navigation__${layout == 'portal' ? 'portal-linebreak' : 'linebreak'}`"/>
                <the-consent-toggle 
                    class="px-3 my-1" 
                    switchColor="primary" 
                    :toggled="{toggleState: isAllToggled(consent.description), id: -1, parentDescription: consent.description}" 
                    @setState="setState" 
                    @openDropdown="dropdowns[consent.description] = !dropdowns[consent.description]"
                    :title="consent.description" 
                    :icon="consent.children.length > 1 ? dropdowns[consent.description] ? 'fxt-chevron-down' : 'fxt-chevron-up' : ''" 
                    :indeterminate="indeterminate(consent.description)">
                </the-consent-toggle>
                <v-expand-transition v-if="consent.children.length > 1">
                    <div v-if="dropdowns[consent.description]">
                        <div v-for="subConsent in consent.children" :key="subConsent.consentTypeId">
                            <the-consent-toggle 
                            class="pr-3 pl-12" 
                            iconSize="20px" 
                            switchColor="primary" 
                            :toggled="{toggleState: subConsent.responseValue, id: subConsent.consentTypeId, parentDescription: consent.description}" 
                            :disabled="false" @setState="setState" 
                            :title="subConsent.consentCategory" 
                            :icon="icon(subConsent.consentTypeId)">
                            </the-consent-toggle>
                        </div>
                    </div>
                </v-expand-transition>
            </div>
            <div class="d-flex justify-end">
                <v-btn
                class="secondary-font text-none mt-8"
                color="primary"
                rounded
                elevation="0"
                :disabled="!hasChanged"
                @click="saveConsents()"
                >
                    Lagre samtykker
                </v-btn>
            </div>
        </div>
        <div v-else>
            <v-overlay :value="loading" color="white" absolute style="height: 600px">
                <v-progress-circular
                    color="var(--v-primary-base)"
                    indeterminate
                    size="64"
                ></v-progress-circular>
            </v-overlay>
        </div>
    </div>
</template>

<script>
import { TheConsentToggle, ProfileDropdown, TitleAndEdit } from '../../../Common/CommonComponents'
import ProfileSvc from '../../../../services/profile-svc';
let profileSvc = null;
export default {
    components: { TheConsentToggle, ProfileDropdown, TitleAndEdit },
    props: {
        user: {
            required: true,
            default: '',
            type: Object,
        },
        layout: {
            required: false,
            default: 'chain',
            type: String
        }
    },
    data() {
        return {
            consents: [],
            consentsOriginal: [],
            hasChanged: false,
            chains: [],
            currentChainId: 0,
            loading: false,
            allToggled: false,
            selectedChain: '',
            dropdowns: {
                'Informasjon, nyheter og tilbud fra fixit': false,
                'Fordelsprogram': false,
                'Timeanbefalinger': false,
                'Informasjon, nyheter og tilbud fra salonger': false,
                'Informasjon, nyheter og tilbud': false
            }
        };
    },
    methods: {
        async saveConsents() {
            if (this.chainId == 0) {
                await profileSvc.UpdateOnlineSluttKundeConsents(this.bookingApi, this.consents)
            } else {
                await profileSvc.UpdateCustomerConsents(this.bookingApi, this.consents, this.chainId, false)
            }
        },
        setState(state) {
            /**
             * id = -1 means the user clicked a parent consent toggle, which will toggle all subconsents.
             */
            if (state.id != -1) {
                this.consents.find(x => x.description == state.parentDescription).children.find(x => x.consentTypeId == state.id).responseValue = state.toggleState
            } else {
                var toggleValue = !this.isAllToggled(state.parentDescription)
                for(var c of this.consents.find(x => x.description == state.parentDescription).children) {
                    c.responseValue = toggleValue
                }
            }
        },
        indeterminate(parentDescription) {
            var consents = this.consents.find(x => x.description == parentDescription)
            return consents.children.filter(x => x.responseValue == true).length != 0 && consents.children.filter(x => x.responseValue == true).length != consents.children.length
        },
        isAllToggled(consentDescription) {
            return this.consents.find(x => x.description == consentDescription).children.map(x => x.responseValue).every(state => state === true)
        },
        icon(consentTypeId) {
            switch (consentTypeId) {
                case 1:
                case 2:
                case 3:
                    return 'fxt-comment'
                case 4:
                case 5:
                    return 'fxt-mail'
                case 6:
                    return 'fxt-check'
            }
        },
        async updateSalonList(chain) {
            this.loading = true
            this.consents = (chain == 'Fixit og nye salonger') 
            ? this.consents = await profileSvc.GetUserConsents(this.bookingApi, 0) 
            : this.consents = await profileSvc.GetUserConsents(this.bookingApi, this.chains.find(x => x.chainName == chain).chainId)
            this.currentChainId = chain == 'Fixit og nye salonger' ? 0 : this.chains.find(x => x.chainName == chain).chainId
            this.loading = false
        },
    },
    computed: {
        consentsDescription() {
            return this.chainId == 0 ? 'Hva trender og når kan jeg gjøre et kupp? Få full oversikt over siste nytt ved å huke av for ønsket informasjon fra Fixit!' : 'Hva trender og når kan jeg gjøre et kupp? Få full oversikt over siste nytt ved å huke av for ønsket informasjon fra Salongen.'
        },
        chainId() {
            return this.layout == 'portal' ? this.currentChainId : this.$store.getters["cmsConfigHomepage/getChainId"] ? this.$store.getters["cmsConfigHomepage/getChainId"] : this.$route.params.chainId
        },
        bookingApi() {
            return this.layout == 'portal' ? process.env.VUE_APP_FIXIT_NO_BOOKING_URL : this.$config.VUE_APP_FIXIT_NO_BOOKING_URL ? this.$config.VUE_APP_FIXIT_NO_BOOKING_URL : process.env.VUE_APP_FIXIT_NO_BOOKING_URL
        },
        fixitConsent() {
            return this.consents.find(x => x.description.includes('fra fixit'))
        },
        salonConsents() {
            return this.consents.filter(x => !x.description.includes('fra fixit'))
        },
    },
    watch: {
        consents: {
            handler: {
                deep: true,
                handler(val) {
                    // Compare the original consents data to the changed value to determine wether it's been altered.
                    this.consentsOriginal === JSON.stringify(val) ? this.hasChanged = false : this.hasChanged = true;
                }
            },
        },
    },
    async created() {
        profileSvc = await ProfileSvc(this.$axios);
        this.loading = true
        this.consents = await profileSvc.GetUserConsents(this.bookingApi, this.chainId)
        this.consentsOriginal = JSON.stringify(this.consents)
        if (this.layout == 'portal') {
            var salons = await profileSvc.GetMyVisitedSalons(this.bookingApi)
            this.chains = salons.map(x => {return {chainId: x.chainId, chainName: x.name}})
            if (this.$route.query.chainId) {
                this.selectedChain = this.chains.find(x => x.chainId == this.$route.query.chainId).chainName
            }
        }
        this.loading = false
	},
    beforeDestroy() {
		profileSvc = null
	}
}
</script>